import styled from "styled-components";

export const Container = styled.div`
	width: 600px;
	height: 288px;
	border-radius: 8px;

	.notice-btn {
		border-radius: 8px;
		height: 288px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		color: black;

		transition: 500ms;

		-webkit-box-shadow: -1px -2px 24px -7px rgba(0, 0, 0, 0.75);
		-moz-box-shadow: -1px -2px 24px -7px rgba(0, 0, 0, 0.75);
		box-shadow: -1px -2px 24px -7px rgba(0, 0, 0, 0.75);

		img,
		.imageShadow {
			background-color: gray;
			width: 180px;
			border-radius: 8px 0 0 8px;
			transition: 500ms;
			height: 100%;
		}
		.content {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-between;
			width: calc(100% - 180px - 5px);

			h2 {
				white-space: nowrap;
				max-width: 100%;
				overflow: hidden;
				text-overflow: ellipsis;
				font-size: 28px;
				font-weight: 700;
			}

			.desc {
				height: calc(257px - 20px - 30px);
				display: flex;
				flex-direction: column;
				width: 100%;
				padding: 10px;
				gap: 20px;
				p {
					text-align: left;
					display: -webkit-box;
					-webkit-line-clamp: 7;
					-webkit-box-orient: vertical;
					overflow: hidden;
					height: 140px;
				}
				.desc-btn {
					color: var(--main-green);
					font-weight: 700;
				}
			}
		}
	}

	.notice-btn:hover {
		scale: 1.02;
		border: 2px solid var(--light-green);
		img {
			margin-left: -2px;
		}
	}
`;
